import React from 'react'
import "./Home.css";
import {Link} from "react-router-dom";
import Carousel from "react-bootstrap/Carousel"

function Home() {
    return (
        <div className="home">
             <Carousel>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/HP-NNP5509-1600x460-25thoct.jpg"
                    alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/2008271_bbpl-staples_460.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/2008189_fmcg_t2_Chandigarh_460.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/HP_Mango_justarrived_1600x460_22ndMar21.jpg"
                    alt="fourth slide"
                    />
                </Carousel.Item>
            </Carousel>
            
            <article className="container">
            <article className='mt-5 mb-5' >
            <center>
            <pre>
            <Link to='/category/ahome' className='text-decoration-none'> <img width='150px' style={{borderRadius:'5px'}} src="https://www.bigbasket.com/media/uploads/banner_images/T2_All_Home-Kitchen_Dt_190x60_25july.jpg" alt=""/>  </Link>
            <Link to='/category/ceggs-cmeat-cfish' className='text-decoration-none'> <img style={{borderRadius:'5px'}} width='150px' src="https://www.bigbasket.com/media/uploads/banner_images/T2_All_EggsMeatFish_Dt_190x60_25july.jpg" alt=""/>  </Link>
            <Link to='/category/acombo' className='text-decoration-none'> <img width='150px' style={{borderRadius:'5px'}} src="https://www.bigbasket.com/media/uploads/banner_images/T2_All_ComboStore_Dt_190x60_25july.jpg" alt=""/>  </Link>
            <Link to='/category/adealsofweek' className='text-decoration-none'> <img width='150px' style={{borderRadius:'5px'}} src="https://www.bigbasket.com/media/uploads/banner_images/T2_All_DOW_Dt_190x60_25july.jpg" alt=""/>  </Link>
            </pre>
            </center>
            </article>
           
            <Carousel>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/2011086_chocolate-giftpack_400.jpg"
                    alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/2007024_organic-store_400_25thJuly.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/HP_EP_Holi-Store_1130x400_22ndMar21.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={5000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/2008017_health-safety_400.jpg"
                    alt="fourth slide"
                    />
                </Carousel.Item>
            </Carousel>  
            <h5 className=" text-center mt-4">Bank offfer</h5><hr/>
            <article className="staples_row mb-3">
                <article className="staples_div">
                    <article className="staples_col">
                        <img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/5dc7d80a-0a84-429b-8851-d86958861f6d/T2_All_BOB_DT_1_480x360_16thAug.jpg" alt=""/>
                    </article>
                    <article className="staples_col">
                        <img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/5dc7d80a-0a84-429b-8851-d86958861f6d/T2_All_Induslnd_DT_2_480x360_16thAug.jpg" alt=""/>  
                    </article>
                </article>
                <article className="staples_div">
                    <article className="staples_col">
                    <img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/5dc7d80a-0a84-429b-8851-d86958861f6d/T2_All_Yesbank_DT_3_480x360_16thAug.jpg" alt=""/>  
                    </article>
                    <article className="staples_col">
                        <img className="staples" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/5dc7d80a-0a84-429b-8851-d86958861f6d/T2_All_IDBI_DT_4_480x360_16thAug.jpg" alt=""/>
                    </article>
                </article>
            </article>       
            <h5 className=" text-center mt-4">Fruits and vegitables corner</h5><hr/>
            <article className="row mb-3">
                <article className="col-md-6">
                <Link to='/C1'>
                <img className="FruitAndVegitable_image"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/6f0fa4ae-f5f6-47c3-9bd1-dd06937c3d07/2007024_organic-store_25july.jpg" alt=""/>
                </Link>
                    
                </article>
                <article className="col-md-6 veggie">
               
                        <article className="col-md-6">
                          <Link to='/category/fresh fruits'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/6f0fa4ae-f5f6-47c3-9bd1-dd06937c3d07/T2_All_fruits_DT_2_480x360_25july.jpg" alt=""/></Link>
                        </article>
                        <article className="col-md-6">
                          <Link to='category/daily vegetable'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/6f0fa4ae-f5f6-47c3-9bd1-dd06937c3d07/T2_All_Veggies_DT_4_480x360_25july.jpg" alt=""/></Link>
                        </article>
                </article>
            </article>
            <article className="row mb-3">
                <article className="col-md-6">
                </article>
                <article className="col-md-6 veggie2">
               
                        <article className="col-md-6">
                        <Link to='category/aherbs'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/6f0fa4ae-f5f6-47c3-9bd1-dd06937c3d07/2008101_herbs_25july.jpg" alt=""/></Link>
                        </article>
                        <article className="col-md-6">
                          <Link to='/category/exotic'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/6f0fa4ae-f5f6-47c3-9bd1-dd06937c3d07/2008102_exotic-corner_25july.jpg" alt=""/></Link>
                        </article>
                </article>
            </article>
            <h5 className=" text-center mt-4">Your daily staples</h5><hr/>
            <article className="staples_row mb-3">
                <article className="staples_div">
                <Link to='/category/aata'>
                    <article className="staples_col">
                        <img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/beab1880-2209-40c7-af93-475b74467fe5/2008118_atta-flour_Chandigrah_25july.jpg" alt=""/>
                    </article>
                </Link>
                    <Link to='/category/rice'>
                    <article className="staples_col">
                        <img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/beab1880-2209-40c7-af93-475b74467fe5/2008119_rice_Chandigrah_25july.jpg" alt=""/>  
                    </article>
                    </Link>
                </article>
                <article className="staples_div">
                    <Link to='/category/oil'>
                    <article className="staples_col">
                    <img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/beab1880-2209-40c7-af93-475b74467fe5/2008120_cooking-oil_Chandigrah_25july.jpg" alt=""/>  
                    </article>
                    </Link>
                    <article className="staples_col">
                    <Link to='/category/asalt'><img className="staples"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/beab1880-2209-40c7-af93-475b74467fe5/2008121_salt_Chandigrah_25july.jpg" alt=""/></Link>
                    </article>
                </article>
            </article>

            <h5 className=" text-center mt-4">The snack corner</h5><hr/>
            <article className="row mb-3">
                <article className="col-md-6">
                <Link to='/category/frozen snacks'> <img className="FruitAndVegitable_image"src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/3d10f141-4ae9-4a70-8c60-93c0f9dfd8aa/2008096_frozen-snacks.jpg" alt=""/></Link>
                </article>
                <article className="col-md-6 veggie">
               
                        <article className="col-md-6">
                        <Link to='/category/biscuits'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/3d10f141-4ae9-4a70-8c60-93c0f9dfd8aa/2008010_biscuit-cookies_27july.jpg" alt=""/></Link>
                        </article>
                        <article className="col-md-6">
                        <Link to='/category/chips'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/3d10f141-4ae9-4a70-8c60-93c0f9dfd8aa/2008056_chip-nacho-namkeen.jpg" alt=""/></Link>
                        </article>
                </article>
            </article>
            <article className="row mb-3">
                <article className="col-md-6">
                </article>
                <article className="col-md-6 veggie2">
               
                        <article className="col-md-6">
                        <Link to='/category/aenergybars'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/3d10f141-4ae9-4a70-8c60-93c0f9dfd8aa/2008060_energy-bar-cereals.jpg" alt=""/></Link>
                        </article>
                        <article className="col-md-6">
                        <Link to='/category/ready to cook'><img className="FruitAndVegitable_image" src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/3d10f141-4ae9-4a70-8c60-93c0f9dfd8aa/2008058_rtc-soups-noodles.jpg" alt=""/></Link>
                        </article>
                </article>
            </article>

            <h5 className=" text-center mt-4">Brand store</h5><hr/>
            <pre>
            <Link to='/category/amul'><img className="mr-4" width='200px' src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/ebbec88b-5434-467d-a29f-d2f99c55621c/All_Amul_480x360_27thJuly.jpg" alt=""/></Link>
            <Link to='/category/dettol'><img className="mr-4" width='200px' src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/ebbec88b-5434-467d-a29f-d2f99c55621c/All_Dettol_480x360_27thJuly.jpg" alt=""/></Link>
            <Link to='/category/loreal paris'><img className="mr-4" width='200px' src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/ebbec88b-5434-467d-a29f-d2f99c55621c/All_Loreal_480x360_27thJuly.jpg" alt=""/></Link>
            <Link to='/category/patanjali'><img className="mr-4"  width='200px' src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/ebbec88b-5434-467d-a29f-d2f99c55621c/All_Patanjali_480x360_27thJuly.jpg" alt=""/></Link>
            <Link to='/category/thums up'><img className="mr-4" width='200px' src="https://www.bigbasket.com/media/customPage/9fd1bf7c-7698-409a-833d-1af7936d3aa4/bd543d87-444b-44e9-8c7c-069915867c38/8445550a-da01-4231-b08c-bfa158ce753f/2-2.jpg" alt=""/></Link>
            <Link to='/category/coca cola'><img width='200px' src="https://www.bigbasket.com/media/customPage/8b73190c-8eda-4a77-b416-3b04e5bbec6e/6a5151a6-2dcc-4834-aaf1-512c9231abfd/ebbec88b-5434-467d-a29f-d2f99c55621c/All_Cocacola_480x360_27thJuly.jpg" alt=""/></Link>
            </pre>
        </article>        
        </div>
    )
}

export default Home
